import { SET_FEATURE_FLAG } from 'constants/ActionTypes';

const setFeatureFlag = (featureFlag) => ({ type: SET_FEATURE_FLAG, featureFlag });

export default setFeatureFlag;
